import { useState } from "react";
import { Navigation } from "../components/Navigation";
import { HeroSection } from "../components/HeroSection";
import { ServicesSection } from "../components/ServicesSection";
import { AboutSection } from "../components/AboutSection";
import { GallerySection } from "../components/GallerySection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { ContactFormModal } from "../components/ContactFormModal";

export const LandingPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navigation onContactClick={openContactModal} />
      <main>
        <HeroSection onGetQuoteClick={openContactModal} />
        <ServicesSection />
        <AboutSection />
        <GallerySection />
        <TestimonialsSection onGetQuoteClick={openContactModal} />
        <ContactSection onGetQuoteClick={openContactModal} />
      </main>
      <Footer />
      <ContactFormModal isOpen={isContactModalOpen} onClose={closeContactModal} />
    </div>
  );
};
